import CVDCardGenetics from "../../../../../../components/Cards/CVDCardGenetics";
import CardElements from "../../../../../../components/TextComps/CardElements";
import Dia_FTO from "./FTO/Dia_FTO"
import Dia_FTO_Variants from "./FTO/Dia_FTO_Variants";
import Dia_FTO_Signal from "./FTO/Dia_FTO_Signal";
import Dia_Leptin from "./Leptin/Dia_Leptin";
import Dia_Leptin_Variants from "./Leptin/Dia_Leptin_Variants";
import Dia_Leptin_Signal from "./Leptin/Dia_Leptin_Signal";
import Dia_Mono from "./Mono/Dia_Mono";
import Dia_Mono_Variants from "./Mono/Dia_Mono_Variants";
import Dia_Mono_Signal from "./Mono/Dia_Mono_Signal";
import Dia_Struct from "./Struct/Dia_Struct";
import Dia_Struct_Variants from "./Struct/Dia_Struct_Variants";
import Dia_Struct_Signal from "./Struct/Dia_Struct_Signal";


export default function Obesity() {

return (
<>
<CVDCardGenetics  

        cardheadline='OBESITY'
        content = {<>
                 
                 <CardElements element1={<Dia_FTO />} element2={<Dia_FTO_Variants />} element3={<Dia_FTO_Signal />} />
                 <CardElements element1={<Dia_Leptin />} element2={<Dia_Leptin_Variants />} element3={<Dia_Leptin_Signal />} />
                 <CardElements element1={<Dia_Mono />} element2={<Dia_Mono_Variants />} element3={<Dia_Mono_Signal />} />
                 <CardElements element1={<Dia_Struct />} element2={<Dia_Struct_Variants />} element3={<Dia_Struct_Signal />} />
                

    </>}   
    
/>    
</>

)};
